import React, { useEffect, useState } from "react";

import Alert from "@mui/material/Alert";

// import PortalMessaging from "./portalMessaging";
import PortalPrescriptionRefills from "./portalPrescriptionRefills.jsx";

// PortalIndex shows a dismissible notice when the patient was redirected here from a visit flow
// because they already have a visit in progress for that vertical. The visits bundle sets
// ?notice=pending_visit on the redirect (checkAndRedirectIfPendingVisitOfTypeExists) because the
// hard cross-bundle navigation does not preserve React state.
export default function PortalIndex() {
  const [showPendingNotice, setShowPendingNotice] = useState(
    () =>
      typeof window !== "undefined" &&
      new URLSearchParams(window.location.search).get("notice") ===
        "pending_visit",
  );

  // Strip the notice param from the URL once it's been consumed into state, so a reload,
  // back/forward navigation, or bookmark of this URL doesn't resurrect the banner after it was
  // dismissed or the pending visit was resolved.
  useEffect(() => {
    if (typeof window === "undefined") return;
    const url = new URL(window.location.href);
    if (url.searchParams.get("notice") !== "pending_visit") return;
    url.searchParams.delete("notice");
    window.history.replaceState(window.history.state, "", url.toString());
  }, []);

  // The parent layout renders this route into a `display: flex` (row) container
  // (see portalStyles.mainContent). Returning the Alert and the content as bare
  // siblings made each a flex item, so the notice rendered as a tall column
  // beside the page (squeezing it right and overflowing the fixed header). We
  // wrap everything in a single full-width flex-COLUMN item: the notice becomes
  // a flush, full-width banner at the top and the content fills the rest.
  return (
    <div
      style={{
        flexGrow: 1,
        minWidth: 0,
        display: "flex",
        flexDirection: "column",
      }}
    >
      {showPendingNotice && (
        <Alert
          severity="info"
          onClose={() => setShowPendingNotice(false)}
          sx={{ borderRadius: 0, alignItems: "center" }}
        >
          You already have a visit in progress. You can manage it below.
        </Alert>
      )}
      <PortalPrescriptionRefills />
    </div>
  );
}
